import { createRouter, createWebHashHistory } from 'vue-router'
import BasicLayout from  '../views/layouts/BasicLayout.vue'

const routes = [
  {
    path: '/',
    component: BasicLayout,
    children: [
      {
        path: '/',
        redirect: '/index'
      },
      {
        path: '/index',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: { title: '首页', index: 1 }
      },
      {
        path: '/feature',
        name: 'feature',
        component: () => import('@/views/Feature'),
        meta: { title: '特征抽取', index: 1 }
      },
      {
        path: '/face',
        name: 'face',
        component: () => import('@/views/Face'),
        meta: { title: '人脸识别', index: 1 }
      },
      {
        path: '/speak',
        name: 'speak',
        component: () => import('@/views/Speak'),
        meta: { title: '语速检测', index: 1 }
      },
      {
        path: '/das',
        name: 'das',
        component: () => import('@/views/DAS'),
        meta: { title: 'DAS数据库访问框架', index: 1 }
      },
      {
        path: '/cloud',
        name: 'cloud',
        component: () => import('@/views/Cloud'),
        meta: { title: '容器云平台', index: 1 }
      },
      {
        path: '/kraken',
        name: 'kraken',
        component: () => import('@/views/Kraken'),
        meta: { title: '章鱼智能投放平台', index: 1 }
      },
      {
        path: '/three',
        name: 'three',
        component: () => import('@/views/Three'),
        meta: { title: '三方数据管理平台', index: 1 }
      },
    ]
  },
  {
    path: '/404',
    name: 'Error404',
    redirect: '/index'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) { 
    from.name ? next({
      name: from.name
    }) : next('/404'); 
  } else {
    next();
  }
});

export default router
